module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'VehicleCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn"
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "vehicleTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b31d9540", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b31d9540"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/vehicles/Vehicles.vue
// module id = 2374
// module chunks = 0